export const SYSTEM_ACTION_TYPES = {
    SET_BG_IS_CHANGING: 'system/SET_BG_IS_CHANGING',
    SET_DISPLAYED_GRADIENT: 'system/SET_DISPLAYED_GRADIENT',
    SET_DEFAULT_GRADIENT: 'system/SET_DEFAULT_GRADIENT',
    SET_GRADIENT_A: 'system/SET_GRADIENT_A',
    SET_GRADIENT_B: 'system/SET_GRADIENT_B',
    SET_SYSTEM_NOTIFICATION: 'system/SET_SYSTEM_NOTIFICATION',
    SET_CRITICAL_MESSAGE: 'system/SET_CRITICAL_MESSAGE',
    SET_CHECKLIST_SPORT_DEFAULT: 'system/SET_CHECKLIST_SPORT_DEFAULT',
    SET_CHECKLIST_YEAR_DEFAULT: 'system/SET_CHECKLIST_YEAR_DEFAULT',
    SET_CHECKLIST_MANUFACTURER_DEFAULT: 'system/SET_CHECKLIST_MANUFACTURER_DEFAULT',
    SET_CHECKLIST_SERIES_DEFAULT: 'system/SET_CHECKLIST_SERIES_DEFAULT',
    SET_CHECKLIST_CARD_TYPE_DEFAULT: 'system/SET_CHECKLIST_CARD_TYPE_DEFAULT',
    SET_CHECKLIST_CARD_TYPE_CATEGORY_DEFAULT: 'system/SET_CHECKLIST_CARD_TYPE_CATEGORY_DEFAULT',
    RESET_SYSTEM_STATE: 'system/RESET_SYSTEM_STATE'
};